/**
 * IAM routes on the same backend as CRM (`/user/api/...`).
 * See {@link backendUrl} in `src/config/backend.ts`.
 */
import { backendUrl } from './backend';
/** Build IAM URL (`/user/api/...` relative or absolute against {@link BACKEND_URL}). */
export function userIamUrl(pathFromUserSlash) {
    const rel = pathFromUserSlash.startsWith('/') ? pathFromUserSlash : `/${pathFromUserSlash}`;
    return backendUrl(rel);
}
